import React from "react";
import { useIntl } from "gatsby-plugin-react-intl";
import { StaticImage } from "gatsby-plugin-image";

import * as S from "./styled";

function TextImageTalents() {
  const intl = useIntl();

  const title = intl.formatMessage({ id: "talents.text_image.title" });

  return (
    <S.TextImageTalentsWrapper>
      <S.BoxText>
        <S.Title>{title}</S.Title>
        <S.BoxImageMobile>
          <StaticImage src="../../images/talents/text-image.png" alt={title} />
        </S.BoxImageMobile>
        <S.P>{intl.formatMessage({ id: "talents.text_image.text_1" })}</S.P>
        <S.P2>
          {intl.formatMessage({ id: "talents.text_image.text_2_a" })}{" "}
          <span>
            {intl.formatMessage({ id: "talents.text_image.text_2_b" })}
          </span>{" "}
          {intl.formatMessage({ id: "talents.text_image.text_2_c" })}
        </S.P2>
        <S.SmallLink
          href="https://engineering.axur.com/2020/07/08/pilares-tecnicos.html"
          target="_blank"
          rel="noreferrer"
        >
          {intl.formatMessage({ id: "talents.text_image.link" })}
        </S.SmallLink>
      </S.BoxText>

      <S.BoxImage>
        <StaticImage src="../../images/talents/text-image.png" alt={title} />
      </S.BoxImage>
    </S.TextImageTalentsWrapper>
  );
}
export default TextImageTalents;
